import WebStorage from '@/libs/Storage/webStorage';
import { getParamType } from '@/libs/global';

export default {
  namespaced: true,
  state: {
    navTitle: '',
    uuid: WebStorage.getLocal('uuid') || '',
    timestamp: WebStorage.getLocal('timestamp') || '',
    isReqLoadingShow: '',
    isModalShow: true,
    cardNo: WebStorage.getLocal('cardNo') || '',
    exchangeResult: WebStorage.getLocal('exchangeResult') || '',
    isBtnDisabled: false
  },
  mutations: {
    SET_PARAM (state, data) {
      const paramType = getParamType(data);

      if (paramType === 'Array') {
        data.forEach(({ field, value }) => {
          state[field] = value;
          WebStorage.setLocal(field, value);
        });
      } else if (paramType === 'Object') {
        state[data.field] = data.value;
        WebStorage.setLocal(data.field, data.value);
      }
    },
    SET_REQ_LOADING (state, isShow) {
      state.isReqLoadingShow = isShow;
    }
  },
  actions: {

  }
};
